/**
 *  Logic that is used to cast the needed data in a specific model.
 */
import { forOwn, } from './../../utils';
/**
 *  Used for casting a value to a valid date. The method returns the original
 *  value if it could not be casted to a valid date object.
 */
function castDate(value) {
    if (!value || value instanceof Date) {
        return value;
    }
    const parsed = Date.parse(value);
    return !isNaN(parsed) ? new Date(value) : value;
}
export function event(event) {
    event.status_until = castDate(event.status_until);
    event.start = castDate(event.start);
    event.end = castDate(event.end);
}
export function eventDate(eventDate) {
    eventDate.start = castDate(eventDate.start);
    eventDate.end = castDate(eventDate.end);
}
export function ticket(ticket) {
    ticket.available_from = castDate(ticket.available_from);
    ticket.available_until = castDate(ticket.available_until);
}
/**
 *  Used for casting a collection of models.
 */
function castMultiple(models, method) {
    forOwn(models, method);
}
export function events(events) {
    castMultiple(events, event);
}
export function eventDates(eventDates) {
    castMultiple(eventDates, eventDate);
}
export function tickets(tickets) {
    castMultiple(tickets, ticket);
}
//# sourceMappingURL=cast.js.map